export class CollaborationResult<T = void> {
  public readonly identifier: string;
  public readonly message: string;
  constructor(
    collaborationName: string,
    identifier: string,
    message: string,
    public readonly data?: T,
  ) {
    this.message = `[${collaborationName}] - ${message}`;
    this.identifier = identifier;
  }
}
